import { InitialView } from '@chegg/one-auth'
import { AppRoute } from '@chegg-wt/core/types/core'

export interface AuthModalData {
  redirectTo?: AppRoute
  defaultFlow: InitialView
  origin: AuthModalOrigin
  alwaysParticipate?: boolean
  title?: string
}

export enum AuthModalOrigin {
  CREATE_CITATION_HOMEPAGE = 'create-citation-homepage',
  CHECK_PAPER_HOMEPAGE = 'check-paper-homepage',
  SOURCE_BANNER_PAGE = 'source-banner-page',
  VIEW_PAGE_EXPORT = 'view-page-export',
  CITATION_FORM_PAGE = 'citation-form-page',
  OIM_VIEWPAGE = 'oim-view-page',
  CFC_VIEWPAGE_EXIT_GUEST = 'cfc-viewpage-exit-popup-guest',
  ACCOUNT_STYLE_GATE_VIEWPAGE = 'account-style-gate-viewpage',
  REDESIGNED_UNLOCK_MODAL = 'redesigned-unlock-modal',
  NEW_CITATION_LIST_MODAL = 'new-citation-list-modal',
  UPGRADE_MODAL = 'upgrade-modal',
  NAV_HEADER = 'navigation-header',
  PRICE_TABLE = 'price-table',
  DASHBOARD_PAGE_WIDGET = 'dashboard-page-widget',
  MYACCOUNT_PAGE = 'myaccount-page',
  SOURCE_SELECTION_PAGE = 'source-selection-page',
  BIBLIOGRAPHY_PAGE = 'bibliography-page',
  UCF_UNBLOCK_MODAL = 'ucf-unblock-modal',
  HOMEPAGE_UPGRADE_BANNER = 'homepage-upgrade-banner',
  WRITING_ASSISTANT_PAGE = 'writing-assistant-page',
}

export const AUTH_MODAL_TITLE = 'Create an account to start your free trial'
export const CREATE_AN_ACCOUNT = 'Create an account'
